import { render, staticRenderFns } from "./VSwatches.vue?vue&type=template&id=518a4ec6&"
import script from "./VSwatches.vue?vue&type=script&lang=js&"
export * from "./VSwatches.vue?vue&type=script&lang=js&"
import style0 from "./VSwatches.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports